import {useIsRealUserModeEnabled} from '@aboutyou/data-fetcher';
import {lazy} from '@aboutyou/lazy-imports';
import {FooterSkeleton} from '@aboutyou/logic-components';
import {useInView} from '@aboutyou/ui-components';
import React from 'react';

const FooterStaticCacheable = lazy(
  () =>
    import('./FooterStatic.eager').then(module => ({
      default: module.FooterStaticCacheable,
    })),
  {fallback: <FooterSkeleton />},
);

export const FooterStatic = () => {
  const isRealUserModeEnabled = useIsRealUserModeEnabled();
  const {ref, inView} = useInView<HTMLDivElement>({
    threshold: 0,
    rootMargin: '500px',
    triggerOnce: true,
  });

  if (!isRealUserModeEnabled) {
    // for bots, always render the footer on the server
    return <FooterStaticCacheable />;
  }

  return inView ? <FooterStaticCacheable /> : <FooterSkeleton ref={ref} />;
};
